import { Commit } from 'vuex'

import Recipient from '@/models/recipient'
import { VisaLetterData } from '@/models/visa-letter-data'
import VisaLetterModalSteps from '@/models/visa-letter-modal-steps'

import axios from '@/axios-module'

export enum VisaLetterModalActionTypes {
  GetData = '[VisaLetterModal] GetData',
}

export enum VisaLetterModalMutationTypes {
  GetDataSuccess = '[VisaLetterModal] GetDataSuccess',
  SetRecipientIsChosen = '[VisaLetterModal] SetRecipientIsChosen',
  SetStep = '[VisaLetterModal] SetStep',
  Open = '[VisaLetterModal] Open',
  Close = '[VisaLetterModal] Close',
  Reset = '[VisaLetterModal] Reset',
}

export interface State {
  visible: boolean
  visaLetterData: VisaLetterData | null
  recipients: { [id: number]: Recipient }
  currentStep: VisaLetterModalSteps
}

function initialState(): State {
  return {
    visible: false,
    visaLetterData: null,
    recipients: {},
    currentStep: VisaLetterModalSteps.Info,
  }
}

export default {
  state: initialState,
  getters: {
    visaLetterData(state: State): VisaLetterData | null {
      return state.visaLetterData
    },
    visaLetterRecipients(state: State): { [id: number]: Recipient } {
      return state.recipients
    },
  },
  actions: {
    async [VisaLetterModalActionTypes.GetData](
      { commit }: { commit: Commit },
      bookingId: number,
    ) {
      const response = await axios.get(
        `/customer/bookings/${bookingId}/visa_letter`,
      )

      commit(VisaLetterModalMutationTypes.GetDataSuccess, response.data)
    },
  },
  mutations: {
    [VisaLetterModalMutationTypes.Open](state: State) {
      state.visible = true
    },
    [VisaLetterModalMutationTypes.Close](state: State) {
      state.visible = false
    },
    [VisaLetterModalMutationTypes.Reset](state: State) {
      Object.assign(state, initialState())
    },
    [VisaLetterModalMutationTypes.GetDataSuccess](
      state: State,
      visaLetterData: any,
    ) {
      state.visaLetterData = visaLetterData
    },
    [VisaLetterModalMutationTypes.SetRecipientIsChosen](
      state: State,
      { recipientId, isChosen }: { recipientId: number; isChosen: boolean },
    ) {
      const recipient = {
        ...state.recipients[recipientId],
        id: recipientId,
        isChosen,
      }

      state.recipients = { ...state.recipients, [recipientId]: recipient }
    },
    [VisaLetterModalMutationTypes.SetStep](
      state: State,
      step: VisaLetterModalSteps,
    ) {
      state.currentStep = step
    },
  },
}
